/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment, useState } from 'react'
import { observer } from 'mobx-react'
import { isMobile } from 'react-device-detect'
import useRootStore from '@store/useRootStore'
import * as _ from 'lodash'
import { useOnMount, useOnUnmount } from '@utils/reactExt'
import { Schema$CompanyPick } from '@interface/company-pick'
import * as Utils from '@utils/utils'
// img
import { ArrowIco } from '@shared/Icon/ArrowIcon'
import { PickNoticeIco } from '@shared/Icon/EtcIcon'
import FavoriteActiveImg from '@assets/images/btn/favorite-manage-active.png'
// css
import { TitleWrap } from '@styles/base.style'
import { BackBtn, Button } from '@styles/button.style'
import { HomeContentsWrap, PickList, UserPickWrap, TodayPickProfile, NoticeMoreBtnStyle } from '@views/Home/index.style'
import { ListView } from 'antd-mobile'
import BottomLoading from '@components/BottomLoading'
import NavBar from '@views/Navbar'
import { FavoriteIco } from '@shared/Icon/MatchupIcon'
import { PickFloatingBtn } from '@views/Popup/CompanyPickDetail/index.style'
import { message } from 'antd'
import { FavoriteButton } from '@components/Button/FavoriteButton'
import { AdvButton } from '@components/Button'
import { SPORT_ID_ICON_MAP } from '@shared/SportIdGroup'
import { CompanyPickMatchInfo } from '@views/Home/TodayPick/Components/CompanyPickMatchInfo'
import { CompanyPickComment } from '@views/Home/TodayPick/Components/CompanyPickComment'
import { UserPickSpecialMemberMark } from '@views/Home/UserPick/Components/UserPickSpecialMemberMark'
import AdvImg from '@components/AdvImg'

const FAVORITE_ACTIVE_CLASS = 'active ani'

const dataSource = new ListView.DataSource({
  rowHasChanged: (row1, row2) => row1 !== row2,
})

const CompanyPickDetail: React.FC = () => {
  const { routerStore, globalStore, companyPickStore, matchupStore, logStore } = useRootStore()
  const { favoriteTotalPreMatchCount = 0 } = matchupStore
  const { selectedCompanyPickManager: manager } = companyPickStore
  const [isLoading, setIsLoading] = useState(false)
  const [hasMore, setHasMore] = useState(false)
  const [isShowMore, setIsShowMore] = useState(false)
  const [moreBtnClass, setMoreBtnClass] = useState('page-notice')
  const {
    companyPicks = [],
  } = companyPickStore

  // img
  const imageUrl = globalStore.getIngameImagesUrl()
  const IMAGE_DEFAULT_URL = `${imageUrl}bg/default_img.jpg`

  useOnMount(() => {
    fetch(true).catch(err => console.error(err))
  })

  useOnUnmount(() => {
    companyPickStore.setCompanyPicks([])
  })

  const fetch = async (reset = false) => {
    try {
      setIsLoading(true)

      const params = {
        managerUserPromiseId: manager.userPromiseId,
        offset: reset ? 0 : _.size(companyPicks),
      }
      const result = await companyPickStore.api.companyPick.fetchCompanyPicks(params)
      let newCompanyPicks = result.items
      if (!reset) {
        newCompanyPicks = _.concat(companyPicks, result.items)
      }
      companyPickStore.setCompanyPicks(newCompanyPicks)
      setHasMore(result.hasMore)
    } catch (err) {
      console.error(err)
    } finally {
      setIsLoading(false)
    }
  }

  const onClickPickDetail = (pick: Schema$CompanyPick): void => {
    switch (manager.userNick) {
      case '고정배':
        logStore.writeButtonLog({ pageId: 'a020', buttonId: '002' }).catch(console.error)
        break
      case '될놈될이다':
        logStore.writeButtonLog({ pageId: 'a080', buttonId: '002' }).catch(console.error)
        break
      case '프로키':
        logStore.writeButtonLog({ pageId: 'a090', buttonId: '002' }).catch(console.error)
        break
    }
    companyPickStore.setSelectedCompanyPick(pick)
    globalStore.setVisibleCompanyPickDetailPopup(true)
  }

  const onClickFavoriteMatch = (companyPick: Schema$CompanyPick) => {
    if (!Utils.isNotStartedMatch(companyPick.dateOfMatch)) {
      message.info('현재 찜할 수 없는 경기입니다.')
      return
    }

    switch (manager.userNick) {
      case '고정배':
        logStore.writeButtonLog({ pageId: 'a020', buttonId: '003', buttonDetails: companyPick.tournamentName }).catch(console.error)
        break
      case '될놈될이다':
        logStore.writeButtonLog({ pageId: 'a080', buttonId: '003', buttonDetails: companyPick.tournamentName }).catch(console.error)
        break
      case '프로키':
        logStore.writeButtonLog({ pageId: 'a090', buttonId: '003', buttonDetails: companyPick.tournamentName }).catch(console.error)
        break
    }
    companyPickStore.toggleFavoriteMatch(companyPick).catch(err => console.error(err))
  }

  const renderRow = (row: Schema$CompanyPick) => {

    const favoriteMatchButtonClass = `${Utils.isNotStartedMatch(row.dateOfMatch) ? '' : 'disabled'} ${row.isFavoriteMatch ? FAVORITE_ACTIVE_CLASS : ''}`

    const contents = (
      <div className="pick-item">
        <div className="tournament-info">
          {SPORT_ID_ICON_MAP[row.sportId]}{row.tournamentName}
        </div>

        <AdvButton
          width={'100%'}
          contents={<CompanyPickMatchInfo matchInfo={row} small vertical/>}
          className="pick-match-info-page"
          onClick={() => onClickPickDetail(row)}
        />

        <div className={manager.userProfileImg ? 'sub-info company-pick is-profile-custom' : 'sub-info company-pick'}>
          <span className="line"/>
          <CompanyPickComment
            matchInfo={row}
            avatar={manager.userProfileImg}
          />

          {/* TODO 찜 활성화되었을 시 'active ani' class 추가 / 비활성화시(경기시작이후) 'disabled' 추가 */}
          <FavoriteButton
            id="todayPickFavoriteBtn"
            className={favoriteMatchButtonClass}
            onClick={() => onClickFavoriteMatch(row)}
            hideBg
          />
        </div>
      </div>
    )

    return (
      <UserPickWrap>
        {contents}
      </UserPickWrap>
      // <AdvButton
      //   width={'100%'}
      //   contents={contents}
      //   className="pick-item"
      //   onClick={() => onClickPickDetail(row)}
      // />
    )
  }

  const renderFooter = () => {
    let footer = <Fragment/>
    if (isLoading) {
      footer = <BottomLoading/>
    }
    return <div css={{ textAlign: 'center' }}>{footer}</div>
  }

  const endReachedHandler = async () => {
    if (isLoading) {
      return
    }

    if (hasMore) {
      await fetch()
    }
  }

  const onClickMoveToFavoriteMatchList = () => {
    logStore.writeButtonLog({ pageId: 'a020', buttonId: '004' }).catch(console.error)

    if (favoriteTotalPreMatchCount < 1) {
      return
    }

    companyPickStore.moveToFavoriteMatchList()
  }

  const makeMoveToFavoriteMatchListButtonClass = () => {
    let buttonClass = !isMobile && 'pc-floating-btn'
    buttonClass += (favoriteTotalPreMatchCount < 1 ? ' disabled' : '')
    return buttonClass
  }

  const FavoriteActiveBtn = <img src={FavoriteActiveImg} className="favorite-btn-active-img" alt="favorite-btn-active"
                                 loading="lazy"/>

  let isOverText

  const noticeWrap = document.querySelector('.page-notice')
  const noticeContents = document.querySelector('.page-notice > .notice-contents')

  if (!_.isEmpty(noticeContents)) {
    const noticeWrapWidth = parseInt(window.getComputedStyle(noticeWrap).width, 10)
    const noticeContentsWidth = parseInt(window.getComputedStyle(noticeContents).width, 10)

    if (noticeWrapWidth - 145 < noticeContentsWidth) {
      isOverText = true
    }
  }

  const onClickToggleBtn = () => {
    setMoreBtnClass('adv-hidden')
    const element = document.querySelector('.page-notice')

    if (isOverText && !isShowMore) {
      setIsShowMore(!isShowMore)

      if (_.includes(element.classList, 'open')) {
        element.classList.remove('open')
      } else {
        element.classList.add('open')
      }
    }
  }

  const onClickBackBtn = () => {
    switch (manager.userNick) {
      case '고정배':
        logStore.writeButtonLog({ pageId: 'a020', buttonId: '001' }).catch(console.error)
        break
      case '될놈될이다':
        logStore.writeButtonLog({ pageId: 'a080', buttonId: '001' }).catch(console.error)
        break
      case '프로키':
        logStore.writeButtonLog({ pageId: 'a090', buttonId: '001' }).catch(console.error)
        break
    }

    if (isMobile) {
      routerStore.goBack()
    } else {
      globalStore.setVisibleTodayPickList(true)
      globalStore.setVisibleTodayPick(false)
    }
  }

  return (
    <Fragment>
      <HomeContentsWrap className="today-pick-detail-wrap">
        <TitleWrap className={`title-wrap no-bg no-header ${!isMobile && 'pc'}`}>
          <BackBtn onClick={onClickBackBtn}>
            <ArrowIco/>
          </BackBtn>
        </TitleWrap>


        <div className={isMobile ? 'pick-bg-wrap' : 'pick-bg-wrap pc'}>
          <img src={manager.detailPageBackgroundImageUrl || IMAGE_DEFAULT_URL} alt={`${manager.userNick} 배경 이미지`}
               className={isMobile ? 'pick-page-bg' : 'pick-page-bg pc'} loading="lazy"/>
        </div>

        <TodayPickProfile>
          <div className={manager.isCustomProfileImg ? 'pick-profile big is-profile-custom lhn35' : 'pick-profile big lhn35'}>
            <AdvImg src={manager.userProfileImg} srcMode={'small'} alt={`${manager.userNick} 프로필 이미지`} loading="lazy"/>
          </div>

          <div className="profile-info">
            <div className="nick-name-wrap">
              <h3 className="name">{manager.userNick}</h3>
              <UserPickSpecialMemberMark
                showSMark={manager.hasMark}
                isSpecialMember={manager.isSpecialMember}
                userTitleId={manager.userTitleId}
                userTitleEnabled={manager.userTitleEnabled}
                darkBorder
              />
            </div>
            <p className="introduction">
              여러분의 좋아요와 댓글은<br/>
              분석가에게 큰 힘과 원동력이 됩니다!
            </p>
            <div className="community-score">
              <div className="line"/>
              <span className="txt">총 좋아요 &nbsp;{manager.likeCount}</span>
              <span className="txt">총 댓글 &nbsp;{manager.commentCount}</span>
            </div>
          </div>
        </TodayPickProfile>

        {manager.notice &&
          <div className="notice page-notice">
            <div className="bg"/>
            <PickNoticeIco/>
            <Button TP className={isOverText ? 'txt notice-contents over-txt' : 'txt notice-contents'}
                    onClick={onClickToggleBtn}>{manager.notice}</Button>
            {isOverText &&
              <Button TP css={NoticeMoreBtnStyle} onClick={onClickToggleBtn} className={moreBtnClass}>
                더보기
              </Button>
            }
          </div>
        }

        <UserPickWrap className={!isMobile && 'page-pick-wrap'}>
          <PickList className={!isMobile && 'pc-pick-list'}>
            {companyPicks &&
              <ListView
                dataSource={dataSource.cloneWithRows(companyPicks)}
                renderRow={renderRow}
                scrollRenderAheadDistance={500}
                renderFooter={renderFooter}
                onEndReached={endReachedHandler}
                onEndReachedThreshold={10}
                initialListSize={9}
                pageSize={9}
                useBodyScroll={isMobile}/>
            }
            {/* TODO 비활성화시 'disabled' 추가 */}
            <PickFloatingBtn
              onClick={onClickMoveToFavoriteMatchList}
              className={makeMoveToFavoriteMatchListButtonClass()}
            >
              <Button className="pick-floating-btn">
                <span className="left-item">{FavoriteActiveBtn}<FavoriteIco/>{favoriteTotalPreMatchCount}</span>
                <ArrowIco/>
              </Button>
            </PickFloatingBtn>
          </PickList>
        </UserPickWrap>
      </HomeContentsWrap>

      {isMobile && <NavBar key="TodayPick:NavBar"/>}
    </Fragment>

  )
}

export default observer(CompanyPickDetail)
